import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { apiUrl } from '../lib/api';
import { LanguageSwitcher, useT, type TKey } from '../i18n';

const NAV: { to: string; label: TKey; icon: string; end?: boolean }[] = [
  { to: '/', label: 'nav.dashboard', icon: '▦', end: true },
  { to: '/licencias', label: 'nav.licenses', icon: '◈' },
  { to: '/clientes', label: 'nav.customers', icon: '◉' },
  { to: '/maquinas', label: 'nav.machines', icon: '▭' },
  { to: '/productos', label: 'nav.products', icon: '▤' },
];
const NAV_OPS: { to: string; label: TKey; icon: string }[] = [
  { to: '/activacion-offline', label: 'nav.offline', icon: '⇅' },
  { to: '/auditoria', label: 'nav.audit', icon: '☰' },
  { to: '/webhooks', label: 'nav.webhooks', icon: '↗' },
];

/** Símbolo de Voxel. Lleva facetas negras: sobre fondo oscuro va en una placa blanca. */
export function Logo() {
  return (
    <span className="brand-mark" aria-hidden>
      <img src="/voxel-simbolo.svg" alt="" />
    </span>
  );
}

/** Logo completo (símbolo + "voxel"), para fondos claros. */
export function FullLogo({ height = 38 }: { height?: number }) {
  return <img className="brand-logo" src="/voxel-logo.svg" alt="Voxel" style={{ height }} />;
}

export function Layout() {
  const { session, logout } = useAuth();
  const t = useT();
  return (
    <div className="app">
      <aside className="sidebar">
        <div className="brand">
          <Logo />
          <div>
            {t('nav.appName')}
            <small>{t('nav.appSub')}</small>
          </div>
        </div>
        <nav className="nav">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end}>
              <span aria-hidden>{n.icon}</span> {t(n.label)}
            </NavLink>
          ))}
          <div className="nav-section">{t('nav.operations')}</div>
          {NAV_OPS.map((n) => (
            <NavLink key={n.to} to={n.to}>
              <span aria-hidden>{n.icon}</span> {t(n.label)}
            </NavLink>
          ))}
          <div className="nav-section">{t('nav.reference')}</div>
          <NavLink to="/manual">
            <span aria-hidden>?</span> {t('nav.manual')}
          </NavLink>
          <a href={apiUrl('/docs')} target="_blank" rel="noreferrer">
            <span aria-hidden>⧉</span> {t('nav.api')}
          </a>
        </nav>
        <div className="sidebar-footer">
          <div className="who" title={session?.email ?? ''}>
            {session?.name ?? session?.email ?? t('nav.admin')}
          </div>
          <div className="muted" style={{ fontSize: 12 }}>
            {session?.method === 'oidc' ? t('nav.corporateSession') : t('nav.localSession')}
          </div>
          <div className="sidebar-actions">
            <button className="btn btn-sm" onClick={() => void logout()}>
              {t('nav.logout')}
            </button>
            <LanguageSwitcher className="dark" />
          </div>
        </div>
      </aside>
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
